import { Component } from 'components/sensors-and-connectors';

/** @ngInject */
export default function sensorsAndConnectorsRouter($stateProvider) {
    $stateProvider
        .state('main.sensors', {
            abstract: true,
            views: {
                content: {
                    component: Component.selector
                }
            }
        })
        .state('main.sensors.list', {
            url: '/sensors-and-connectors?q&tabId',
            reloadOnSearch: false,
            component: 'dtSensorListContainer'
        })
        .state('main.sensors.list.search', {
            url: '/search',
            views: {
                rightPanel: {
                    component: 'dtThingsSearchAdvanced'
                }
            }
        })
        .state('main.sensors.list.thing', {
            url: '/{thingId}',
            resolve: {
                /** @ngInject */
                thing(ThingsApi, $stateParams) {
                    return ThingsApi.entity($stateParams.thingId).catch(() => null);
                }
            },
            /** @ngInject */
            onEnter(thing, $state) { // eslint-disable-line consistent-return
                if (!thing) {
                    return $state.target('main.sensors.list');
                }
            },
            views: {
                rightPanel: {
                    component: 'dtThingDetails'
                }
            }
        })
        .state('main.sensors.list.thing.graph', {
            url: '/graph',
            views: {
                'centralPanel@^.^': { // ^ means go level up in state hierarchy
                    component: 'dtThingChart'
                }
            }
        })
    ;
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/sensors.router.js